import { useCallback, useEffect, useState, Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingCM from "components/shared/Loading";
import {
  StyledCardContent,
  StyledCardHeader,
  StyledImgContainer,
  StyledTypographyContent,
} from "./News.style";
import { Grid } from "@mui/material";
import BackButton from "components/shared/BackButton";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { FaRegCalendarAlt } from "react-icons/fa";
import useHttp from "hooks/use-http";
import { getArticleInfoRequest } from "api/requests";
import Container from "@mui/material/Container";
import MenuCM from "components/shared/menu";
import FooterCM from "components/shared/footer";
import { IMG_BASE_URL } from "constants";
import Button from "@mui/material/Button";
import LinkIcon from "@mui/icons-material/Link";
import ContactCM from "components/contactus";
import parse from "html-react-parser";
import {Helmet} from "react-helmet";

export default function EachNews() {
  const params = useParams();
  const { request, loading } = useHttp();
  const [news, setNews] = useState([]);
  const [newsText, setNewsText] = useState("");
  const [copied, setCopied] = useState(false);

  function copy() {
    const el = document.createElement("input");
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setCopied(true);
  }

  const getArticle = useCallback(async () => {
    let res = await request({
      url: getArticleInfoRequest,
      values: params.articleId,
    });
    setNews(res);
    setNewsText(res.text);
  }, [request, params.articleId]);

  useEffect(() => {
    getArticle();
  }, [getArticle]);

  return (
    <div>
      <Helmet>
        <title>اطلاعات تولید - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <MenuCM pageTitle="اطلاعات تولید" />
          <Container>
            {/* <Grid item mt={3} xs={12}>
              <BackButton />
            </Grid> */}
            <Card
              sx={{
                marginTop: "30px",
                marginBottom: "30px",
                borderRadius: "15px",
              }}
            >
              <StyledCardContent>
                <Typography variant="body2">{news.title}</Typography>
              </StyledCardContent>
              <StyledCardHeader>
                <FaRegCalendarAlt />
                <span>{news.created_at?.string}</span>
              </StyledCardHeader>
              {news.file_type == "image" ? (
                <StyledImgContainer
                  isWeb
                  src={news?.file}
                  alt={"خبر"}
                  width="100%"
                  height="280px"
                  objectFit="cover"
                />
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "280px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <video
                    src={IMG_BASE_URL + news?.file}
                    controls
                    style={{ width: "500px", margin: "auto", maxWidth: "95%" }}
                  ></video>
                </div>
              )}

              <CardContent>
                <StyledTypographyContent
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "justify" }}
                >
                  {parse(newsText)}
                </StyledTypographyContent>
              </CardContent>
              <CardContent style={{ textAlign: "left" }}>
                <Button
                  variant="outlined"
                  startIcon={<LinkIcon />}
                  onClick={copy}
                  style={{ marginLeft: "10px" }}
                >
                  {!copied ? "کپی لینک مقاله" : "کپی شد"}
                </Button>
              </CardContent>
            </Card>
          </Container>
          <ContactCM All />
          <FooterCM />
        </Fragment>
      )}
    </div>
  );
}
